import { apiClient } from './ticketsApi';
import { ENDPOINTS } from './endpoints';

export const fetchApiNames = async () => {
    try {
        const response = await apiClient.get(`/api${ENDPOINTS.GET_API_NAMES}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching API names:', error.response?.data || error.message);
        throw error;
    }
};

export const fetchApiCalls = async () => {
    try {
        const response = await apiClient.get(`/api${ENDPOINTS.GET_API_CALLS}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching API calls:', error.response?.data || error.message);
        throw error;
    }
};

export const checkAzureAdAccess = async (azureAdId) => {
    try {
        const response = await apiClient.get(`/api${ENDPOINTS.CHECK_AZURE_AD_ACCESS}`, {
            params: { azureAdId }
        });
        return response.data;
    } catch (error) {
        console.error('Error checking Azure AD access:', error.response?.data || error.message);
        throw error;
    }
};

export const fetchMenus = async () => {
    try {
        const response = await apiClient.get(`/api${ENDPOINTS.GET_MENUS}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching menus:', error.response?.data || error.message);
        throw error;
    }
};

export const fetchMyMenuAccess = async () => {
    try {
        const response = await apiClient.get(`/api${ENDPOINTS.GET_MY_MENU_ACCESS}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching menu access:', error.response?.data || error.message);
        throw error;
    }
};
